export default __webpack_public_path__ + "static/media/Teal_icon.54bf3d28.svg";